import { useState } from "react";

import { removeFolders } from "../../../api/projectFolders";
import { archiveProjects } from "../../../api/trash";
import { handleSelected, handleSelectedProject } from "./helpers";

export const useDeleteFoldersProjectAndProjects = ({ onSucces, initialModalOpen, setModalOpen }) => {
  const [selectedFolders, setSelectedFolders] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [lengthArchivedProjects, setlengthArchivedProjects] = useState();

  const handleSelectedFolders = (folderId) => {
    setSelectedFolders((prev) => handleSelected(prev, folderId));
  };

  const handleSelectedProjects = (projectInfo) => {
    setSelectedProjects((prev) => handleSelectedProject(prev, projectInfo));
  };

  const onSuccesDeleting = () => {
    onSucces();
    setIsDeleting(false);
    setSelectedFolders([]);
    setSelectedProjects([]);
  };

  const deleteSelectedFoldersAndProjects = async () => {
    selectedFolders.length && removeFolders(selectedFolders, onSuccesDeleting);

    if (selectedProjects.length) {
      const selectedProjectIds = selectedProjects.map((project) => project.id);
      const params = { projectIds: selectedProjectIds, teamId: selectedProjects[0].teamId };

      await archiveProjects(params, ({ trashFull, lengthArchivedProjects }) => {
        if (trashFull) {
          setModalOpen({ ...initialModalOpen, deleteProjects: true });
          setlengthArchivedProjects(lengthArchivedProjects);
        } else {
          onSuccesDeleting();
        }
      });
    }

    setIsDeleting(true);
  };

  return {
    selectedFolders,
    selectedProjects,

    handleSelectedFolders,
    handleSelectedProjects,

    lengthArchivedProjects,

    setlengthArchivedProjects,

    deleteSelectedFoldersAndProjects,
    isDeleting,
  };
};
